import React, { useEffect, useState } from "react";
import { FaRegStar } from "react-icons/fa";
import about from "./assets/about.webp";
import hero1 from "./assets/heroslide.jpeg";
import hero2 from "./assets/heroslide2.jpeg";
import { AiOutlineAim } from "react-icons/ai";
import { SlSymbolMale } from "react-icons/sl";
import { MdOutlineAutoGraph } from "react-icons/md";
import { supabase } from "../supabase";

import ltlongkamteron from "./assets/ltlongkamteron.webp";
import padmashreerongbongterang from "./assets/padmashreerongbongterang.webp";
import joysing from "./assets/joysing.webp";
import hukursing from "./assets/hukursing.webp";

import { Link } from "react-router-dom";

function Home() {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const { data, error } = await supabase
        .from("gallery")
        .select("id, title, description, url")
        .order("created_at", { ascending: false })
        .limit(6); // 👈 LIMIT ADDED;

      if (error) throw error;

      setGallery(data || []);
    } catch (err) {
      console.error("Error fetching gallery:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <!-- Hero Section --> */}
      <section id="hero" className="hero section dark-background">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row align-items-center gy-5">
            <div className="col-lg-7">
              <div
                className="hero-card shadow-sm"
                data-aos="fade-right"
                data-aos-delay="150"
              >
                <div className="eyebrow d-inline-flex align-items-center mb-3">
                  {/* <i className="bi bi-stars me-2"></i> */}
                  <FaRegStar className="me-2" />
                  <span>Karbi Lammet Amei (KLA)</span>
                </div>
                <div className="content">
                  <h2 className="display-5 fw-bold mb-3">
                    Preserving and promoting Karbi language, literature, and
                    culture since 1966.
                  </h2>
                  <p className="lead mb-4">
                    Karbi Lammet Amei works tirelessly to protect the linguistic
                    and cultural heritage of the Karbi people by promoting
                    literature, research, publications, and community engagement
                    across generations.
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <a href="#about" className="btn btn-primary-ghost">
                      <span>Explore Our Legacy</span>
                      <i className="bi bi-arrow-right ms-2"></i>
                    </a>
                    <a
                      href=""
                      className="glightbox btn-video d-inline-flex align-items-center"
                    >
                      <span className="play-icon d-inline-flex align-items-center justify-content-center me-2">
                        <i className="bi bi-play-fill"></i>
                      </span>
                      <span>Watch Overview</span>
                    </a>
                  </div>
                  {/* <div
                    className="mini-stats d-flex flex-wrap gap-4 mt-4"
                    data-aos="zoom-in"
                    data-aos-delay="250"
                  >
                    <div className="stat d-flex align-items-center">
                      <i className="bi bi-lightning-charge me-2"></i>
                      <span>Fusce aptent interdum</span>
                    </div>
                    <div className="stat d-flex align-items-center">
                      <i className="bi bi-shield-check me-2"></i>
                      <span>Quam nunc tempor</span>
                    </div>
                    <div className="stat d-flex align-items-center">
                      <i className="bi bi-people me-2"></i>
                      <span>Ultricies porta lectus</span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div
                className="media-stack"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <figure className="media primary shadow-sm">
                  <img src={hero1} className="img-fluid" alt="Hero visual" />
                </figure>
                {/* <figure className="media secondary shadow-sm">
                  <img
                    src={hero2}
                    className="img-fluid"
                    alt="Supporting visual"
                  />
                </figure> */}
                <div
                  className="floating-badge d-flex align-items-center shadow-sm"
                  data-aos="fade-down"
                  data-aos-delay="300"
                >
                  <i className="bi bi-award me-2"></i>
                  <span>Karbi Lammet Amei</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /Hero Section --> */}

      {/* <!-- About Section --> */}
      <section id="about" className="about section">
        {/* <!-- Section Title --> */}
        <div className="container section-title" data-aos="fade-up">
          <h2>About</h2>
          <p>
            The Karbi Lammet Amei was formed to develop, preserve and popularize
            Karbi language and literature.
          </p>
        </div>
        {/* <!-- End Section Title --> */}

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row g-4 align-items-stretch">
            <div
              className="col-xl-5 order-lg-2"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <aside className="showcase">
                <figure className="showcase-main">
                  <img src={about} alt="Our Journey" className="img-fluid" />
                  {/* <figcaption
                    className="badge-note"
                    data-aos="zoom-in"
                    data-aos-delay="350"
                  >
                    <i
                      className="bi bi-graph-up-arrow"
                      style={{ padding: "5px 10px" }}
                    >
                      <MdOutlineAutoGraph />
                    </i>
                    <div>
                      <strong>Established</strong>
                      <small>
                        The Karbi Lammet Amei came into existence on 27th March,
                        1966 at the residence of Sar Dhaniram Rongpi, the then
                        C.E.M of Karbi Anglong Autonomous Council.
                      </small>
                    </div>
                  </figcaption> */}
                </figure>
              </aside>
            </div>

            <div
              className="col-xl-7 order-lg-1"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <article className="intro-card">
                <div className="intro-head">
                  <span className="kicker">
                    <FaRegStar />
                    Our Story
                  </span>
                  <h2>Introduction to Karbi Tribe</h2>
                </div>

                <div className="intro-body" style={{ textAlign: "justify" }}>
                  <p>
                    The Karbis constitute an important ethnic group in the hill
                    areas of Assam. They are one of the most numerous and
                    homogenous of the many Tibeto-Burman communities inhabiting
                    Assam. Racially the Karbis belong to the Mongoloid group and
                    linguistically Kuki-Chin sub-group of languages. Although at
                    present, they are found to inhabit in the Karbi Anglong
                    districts, nevertheless, some Karbi inhabited pockets are
                    found in the N.C. Hills, Kamrup, Morigaon, Nogaon and
                    Sonitpur districts of Assam.
                  </p>

                  <div className="feature-list row gy-3">
                   
                    <div
                      className="col-xxl-6"
                      data-aos="fade-up"
                      data-aos-delay="300"
                    >
                      <div className="feature-item">
                        <i className="bi bi-palette2">
                          <SlSymbolMale />
                        </i>
                        <div className="text">
                          <h6>ESTABLISHED</h6>
                          <p>
                            The Karbi Lammet Amei came into existence on 27th
                            March, 1966 at the residence of Sar Dhaniram Rongpi,
                            the then C.E.M of Karbi Anglong Autonomous Council.
                          </p>
                        </div>
                      </div>
                    </div>
                     <div
                      className="col-xxl-6"
                      data-aos="fade-up"
                      data-aos-delay="250"
                    >
                      <div className="feature-item">
                        <i>
                          <AiOutlineAim />
                        </i>
                        <div className="text">
                          <h6>AIM</h6>
                          <p>
                            Preserving the literature, tradition, culture,
                            myths, rituals, folklores, chants and songs. To
                            research and rewrite the old-aged songs and stories
                            and bring them in the global scene. To give ideas
                            and moral support to those who are working for the
                            welfare of the tribe.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="actions d-flex flex-wrap align-items-center gap-3"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <Link to="/about-us" className="btn btn-accent">
                      <i className="bi bi-rocket-takeoff me-1"></i> Explore More
                    </Link>
                    <Link to="//about-us" className="link-more">
                      Learn about our culture{" "}
                      <i className="bi bi-arrow-right-short"></i>
                    </Link>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /About Section --> */}

      {/* <!-- Portfolio Section --> */}
      <section id="portfolio" className="portfolio section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Gallery</h2>
          <p>Check Our Portfolio</p>
        </div>

        <div className="container">
          <div
            className="isotope-layout"
            data-default-filter="*"
            data-layout="masonry"
            data-sort="original-order"
          >
            <div
              className="row gy-4 portfolio-container isotope-container"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {loading ? (
                <p>Loading gallery...</p>
              ) : gallery.length === 0 ? (
                <p>No images found.</p>
              ) : (
                <>
                  {gallery.map((item) => (
                    <>
                      <div className="col-lg-4 col-md-6 portfolio-item isotope-item">
                        <div className="portfolio-wrap">
                          <img
                            src={item.url}
                            alt={item.title}
                            className="img-fluid"
                            loading="lazy"
                          />
                          <div className="portfolio-info p-1">
                            {item.title && <p>{item.title}</p>}
                            {/* {item.description && <p>{item.description}</p>} */}
                            {/* <div className="portfolio-links">
                            <a
                              href={a}
                              className="glightbox"
                              title="Capturing Moments"
                            >
                              <i className="bi bi-zoom-in"></i>
                            </a>
                            <a
                              href="portfolio-details.html"
                              title="More Details"
                            >
                              <i className="bi bi-link-45deg"></i>
                            </a>
                          </div> */}
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </>
              )}
            </div>
            {/* <!-- End Portfolio Container --> */}
          </div>
          <div className="text-center mt-4">
            <Link to="/gallery">View more>></Link>
          </div>
        </div>
      </section>
      {/* <!-- /Portfolio Section --> */}

      {/* <!-- Team Section --> */}
      <section id="team" className="team section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Prominent Members of Karbi Lammet Amei</h2>
          <p>
            Since the day of its formation, Karbi Lammet Amei have had the owner
            to get the service of several dedicated members who have earned for
            themselves not only in the district but in the state level as well
            as national level recognition.
          </p>
        </div>

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row g-3 align-items-stretch justify-content-center">
            <div className="col-md-6 col-lg-3 col-xl-2 col-6">
              <article
                className="member-card h-100"
                data-aos="zoom-in"
                data-aos-delay="150"
              >
                <figure className="member-media">
                  <img
                    src={ltlongkamteron}
                    className="img-fluid"
                    alt="Team member portrait"
                  />
                </figure>
                <div className="member-content">
                  <h3 className="member-name">Lt. Longkam Teron</h3>
                  <p className="member-role">Founder President of KLA</p>
                </div>
              </article>
            </div>

            <div className="col-md-6 col-lg-3 col-xl-2 col-6">
              <article
                className="member-card h-100"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <figure className="member-media">
                  <img
                    src={padmashreerongbongterang}
                    className="img-fluid"
                    alt="Team member portrait"
                  />
                </figure>
                <div className="member-content">
                  <h3 className="member-name">Prof. Rongbong Terang</h3>
                  <p className="member-role">
                    Founder General Secretary of KLA
                  </p>
                </div>
              </article>
            </div>

            <div className="col-md-6 col-lg-3 col-xl-2 col-6">
              <article
                className="member-card h-100"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <figure className="member-media">
                  <img
                    src={joysing}
                    className="img-fluid"
                    alt="Team member portrait"
                  />
                </figure>
                <div className="member-content">
                  <h3 className="member-name">Joysing Tokbi</h3>
                  <p className="member-role">Former Secretary KLA</p>
                </div>
              </article>
            </div>

            <div className="col-md-6 col-lg-3 col-xl-2 col-6">
              <article
                className="member-card h-100"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <figure className="member-media">
                  <img
                    src={hukursing}
                    className="img-fluid"
                    alt="Team member portrait"
                  />
                </figure>
                <div className="member-content">
                  <h3 className="member-name">Mr. Hukursing Rongpi</h3>
                  <p className="member-role">Former President, KLA</p>
                </div>
              </article>
            </div>
          </div>

          <div className="row g-4 mt-2">
            <div className="col-lg-8">
              <div
                className="team-highlight d-flex align-items-center"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="icon-wrap">
                  <i className="bi bi-people"></i>
                </div>
                <div className="copy">
                  <h4 className="title">Membership</h4>
                  <p className="desc mb-0">
                    There are two types of membership in Karbi Lammet Amei. One
                    is ‘Armu Bangphu’ or General Member who are directly
                    involved in the working of the organization. The other is
                    ‘Kai arjon Bangphu’ of ‘Life time Members’ who do not
                    directly involve in the works but are supporters and
                    well-wishers of the organization. An individual can take
                    either of the two memberships or go for both.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 d-flex align-items-stretch">
              <aside
                className="join-card w-100"
                data-aos="fade-left"
                data-aos-delay="250"
              >
                <div className="join-content">
                  {/* <h5 className="mb-2">Want to work with us?</h5> */}
                  <p className="mb-3">
                    La athak kapaklang alam an esonbak ketok kechokche dokok
                    tahaimene, Jasemet kitap aphai, amen, kapaklang aningkan
                    haihui pen apart a lammetkuru, lammetpo, tokbang atum amen
                    haihui chok’lim pen long’et’elang. Lasi prapjin pen
                    kapachokthuji aphan klemponpo : Admin
                  </p>
                  {/* <a href="#" className="btn btn-join">
                    <i className="bi bi-send me-1"></i>
                    Open Positions
                  </a> */}
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- /Team Section --> */}
    </>
  );
}

export default Home;
